import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { date2Front, datetime2Front } from "../../../../utils/converts";
import { formatCurrency } from "../../../../utils/Money";

const getBase64FromUrl = async (url) => {
	const data = await fetch(url);
	const blob = await data.blob();
	return new Promise((resolve) => {
		const reader = new FileReader();
		reader.readAsDataURL(blob);
		reader.onloadend = () => {
			const base64data = reader.result;
			resolve(base64data);
		};
	});
};

const dadosUsuarioPedido = pedido => {
	const {usuario} = pedido;
	const telefones = usuario.telefones;
	const tel = telefones[0];
	const telString = tel ? `(${tel.ddd}) ${tel.numero}` : '';

	const params = {
		layout:{
			fillColor: function (rowIndex, node, columnIndex) {
				return (columnIndex === 0) ? '#dfdfdf' : null;
			}
		},
		colSpan:3,
		table: {
			widths: ['25%', '75%'],
			heights: [10,10,10],
			
			body: [
				[
					{ 
						text: 'NOME',
						bold: true,
						fontSize: 12,
						color: '#000000',
						alignment:'left',
					}, 
					{ 
						text: usuario.nome.toUpperCase(),
						// text: 'asasas',
						fontSize: 12,
						color: '#000000',
						alignment:'left',
					}
				],
				[
					{ 
						text: 'DATA PEDIDO',
						bold: true,
						fontSize: 12,
						color: '#000000',
						alignment:'left',
					}, 
					{ 
						text: datetime2Front(pedido.createAt),
						fontSize: 12,
					}, 
				],
				[
					{ 
						text: 'TELEFONE',
						bold: true,
						fontSize: 12,
						color: '#000000',
						alignment:'left',
					}, 
					{ 
						text: telString ,
						fontSize: 12,
					}, 
				],
				[
					{ 
						text: 'CATÁLOGO',
						bold: true,
						fontSize: 12,
						color: '#000000',
						alignment:'left',
					}, 
					{ 
						text: pedido.catalogo?.apelido.toUpperCase() ?? "-",
						fontSize: 12,
					}, 
				]
			],
		},
	}
	return params;
}

const subHeader = (str) => {
	const params = {
		layout:{
			
			hLineWidth: function (i, node) {
				return  0;
			},
			vLineWidth: function (i, node) {
				return 0;
			},

		},
		margin:[0,20,0,0],
		colSpan:3,
		table: {
			widths: ['100%'],
			body: [
				[
					{ 
						text: str.toUpperCase(),
						bold: true,
						fontSize: 10,
						color: '#000000',
						alignment:'left',
					},
				],
			
			],
		},
	}
	return params;
}

const itemsPedido = pedido => {
	const {items} = pedido;
	const fontSizeItems= 7;

	const arrItems = [
		[
			{ 
				text: 'COD.',
				bold: true,
				fontSize: fontSizeItems,
				color: '#000000',
				alignment:'left',
			},
			{ 
				text: 'QTD.',
				bold: true,
				fontSize: fontSizeItems,
				color: '#000000',
				alignment:'left',
			},
			{ 
				text: 'DESCRIÇÃO',
				bold: true,
				fontSize: fontSizeItems,
				color: '#000000',
				alignment:'left',
			},{ 
				text: 'VL. BRUTO',
				bold: true,
				fontSize: fontSizeItems,
				color: '#000000',
				alignment:'right',
			},{ 
				text: 'DESC. %',
				bold: true,
				fontSize: fontSizeItems,
				color: '#000000',
				alignment:'right',
			},{ 
				text: 'VL. LÍQ.',
				bold: true,
				fontSize: fontSizeItems,
				color: '#000000',
				alignment:'right',
			},
			
		]
	];
	let totalBruto = 0;
	let totalLiquido = 0;
	for(const item of items){
		const arr = [];
		const liquido = item.valor * item.quantidade - (item.valor * item.desconto / 100) * item.quantidade;
		totalLiquido += liquido;
		totalBruto += item.valor * item.quantidade;
		arr.push({text:item.produto?.codigo ?? "-", fontSize: fontSizeItems});
		arr.push({text:item.quantidade, fontSize: fontSizeItems});
		arr.push({text:item.produto?.nome ?? "-", fontSize: fontSizeItems});
		arr.push({text:formatCurrency(item.valor * item.quantidade), fontSize: fontSizeItems,alignment:'right',});
		arr.push({text:item.desconto+'%', fontSize: fontSizeItems,alignment:'right',});
		arr.push({text:formatCurrency(liquido), fontSize: fontSizeItems,alignment:'right',});
		arrItems.push(arr);
	}
	
	arrItems.push([
		{
			// colSpan:3,
			text:'TOTAIS',
			bold: true,
			fontSize: fontSizeItems,
			color: '#000000'
		},
		{},
		{},
		{
			text:formatCurrency(totalBruto),
			bold: true,
			fontSize: fontSizeItems,
			color: '#000000',
			alignment:'right',
		},
		{},
		{
			text:formatCurrency(totalLiquido),
			bold: true,
			fontSize: fontSizeItems,
			color: '#000000',
			alignment:'right',
		},
	])

	const params = {
		layout:{
			fillColor: function (rowIndex, node, columnIndex) {
				// console.log(node.table.body.length);
				return (rowIndex === 0 || rowIndex === node.table.body.length - 1) ? '#dfdfdf' : null;
			}
		},
		margin:[0,0,0,0],
		colSpan:3,
		table: {
			widths: ['12%','12%','40%','12%','12%','12%'],
			
			body: arrItems,
		},
	}
	return params;
}

const valoresFormaPagamento = pedido => {
	const fontSizeItems= 7;

	const arrItems = [
		[
			{ 
				text: 'DESCONTO',
				bold: true,
				fontSize: fontSizeItems,
				color: '#000000',
				alignment:'left',
			},
			{ 
				text: formatCurrency(pedido.desconto),
				fontSize: fontSizeItems,
			},
			{ 
				text: 'PAGAMENTO',
				bold: true,
				fontSize: fontSizeItems,
				color: '#000000',
				alignment:'left',
			},
			{ 
				text: pedido.tipoPagamento,
				fontSize: fontSizeItems,
			},
		],
		[
			{ 
				text: 'VALOR FRETE',
				bold: true,
				fontSize: fontSizeItems,
				color: '#000000',
				alignment:'left',
			},
			{ 
				text: formatCurrency(pedido.valorFrete),
				fontSize: fontSizeItems,
			},
			{ 
				text: 'TARIFA POR PARCELA',
				bold: true,
				fontSize: fontSizeItems,
				color: '#000000',
				alignment:'left',
			},
			{ 
				text: formatCurrency(pedido.tarifaParcela),
				fontSize: fontSizeItems,
			},
		],
		[
			{ 
				text: 'QTD. PARCELAS',
				bold: true,
				fontSize: fontSizeItems,
				color: '#000000',
				alignment:'left',
			},
			{ 
				text: pedido.numeroParcelas,
				fontSize: fontSizeItems,
			},
			{ 
				text: 'VALOR PARCELA',
				bold: true,
				fontSize: fontSizeItems,
				color: '#000000',
				alignment:'left',
			},
			{ 
				text: formatCurrency(pedido.valorParcela),
				fontSize: fontSizeItems,
			},
		],
		[
			{ 
				text: 'DATAS DE VENCIMENTOS',
				bold: true,
				fontSize: fontSizeItems,
				color: '#000000',
				alignment:'left',
			},
			{ 
				colSpan:3,
				text: pedido.datasPagamento.map(e=>date2Front(e)).join(', '),
				fontSize: fontSizeItems,
			},
			
		]
	];

	
	const params = {
		layout:{
			fillColor: function (rowIndex, node, columnIndex) {
				return (columnIndex % 2 === 0) ? '#dfdfdf' : null;
			}
		},
		margin:[0,0,0,0],
		colSpan:3,
		table: {
			widths: ['25%','25%','25%','25%'],
			
			body: arrItems,
		},
	}
	return params;
}

const observacoes = pedido => {
	const fontSizeItems= 7;
	const obs = pedido.obs ?? "NENHUMA";

	const arrItems = [
		[
			{ 
				text: obs === "" ? "NENHUMA" : obs.toUpperCase(),
				fontSize: fontSizeItems,
				alignment:'left',
			},
		]
	];

	
	const params = {
		margin:[0,0,0,0],
		colSpan:3,
		table: {
			widths: ['100%'],
			body: arrItems,
		},
	}
	return params;
}

const viaPedido = (pedido,images,textExtra='') => {
	// console.log(JSON.stringify(pedido));
	const {logoLeka} = images;
	const params = {
		layout:{

			hLineWidth: function (i, node) {
				return 0;
			},
			vLineWidth: function (i, node) {
				return 0;
			},
		},
		table: {
			widths: ['20%', '40%','40%'],
			
			body: [
				[
					{ 
						image:logoLeka, width:110, alignment:'left'
					}, 
					
					{ 
						text: textExtra,
						bold: true,
						fontSize: 10,
						color: 'black',
						alignment:'right',
						margin:[0,12,0,0]
					}, 
					{ 
						text: 'Nº: ' + pedido.sequencia,
						bold: true,
						fontSize: 18,
						color: 'black',
						alignment:'right',
						margin:[0,5]
					}, 
				],
				[
					dadosUsuarioPedido(pedido)
				],
				[
					subHeader('Itens do pedido'),
				],
				[
					itemsPedido(pedido)
				],
				[
					subHeader('Valores e forma de pagamento'),
				],
				[valoresFormaPagamento(pedido)],
				[
					subHeader('Observações'),
				],
				[observacoes(pedido)]

			],
		},
	}
	return params;
}

const loadImages = async () => {
	const urlLogo = "https://leka-template-email.s3.sa-east-1.amazonaws.com/boleto/imagens/logo_empresa_red.png";
	const logoLeka = await getBase64FromUrl(urlLogo);
	return {
		logoLeka
	}
}

export const generatePdf = async pedido => {
	const images = await loadImages();
	var win = window.open("", "_blank");


	const docDefinition = {
		pageSize: "A4",
		pageOrientation: "landscape",
		pageMargins: [ 10,10,10,10 ],
		content: [
			{
				style: "tableExample",
				layout: {
					hLineWidth: function (i, node) {
						return 0;
					},
					vLineWidth: function (i, node) {
						return i === 0 || i === node.table.widths.length ? 0 : 1;
					},

					vLineColor: function (i, node) {
						return "black";
					},
					vLineStyle: function (i, node) {
						
						return { dash: { length: 5 } };
					},
				},
				table: {
					widths: ['50%', '50%'],
					body: [
						[
							viaPedido(pedido,images,'VIA REVENDEDORA'), 
							viaPedido(pedido,images,'VIA DISTRIBUIDOR'), 
						]
					],
				},
			},
		],
	};
	pdfMake.createPdf(docDefinition, null, null, pdfFonts.pdfMake.vfs).open({}, win);
	return;

}